import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button } from 'reactstrap'


class CustomButtonDate extends React.Component {
  render() {
    return (
      <ButtonDate
        onClick={ this.props.onClick }
      >
        { this.props.value === '' ? 'Select date' : this.props.value }
      </ButtonDate>
    )
  }
}

CustomButtonDate.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
}
CustomButtonDate.defaultProps = {
  onClick: () => {},
  value: '',
}

export default CustomButtonDate

const ButtonDate = styled(Button)`
  background-color: #ffffff ;
  border: 1px solid #ffffff ;
  font-family: 'Gotham-Bold' !important;
  font-size: 10px ;
  color: #000000;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/helpers/custom-datepicker.js